import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "../AuthContext";
import { errMsg } from "../api";
import "../admin.css";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user && user !== false) {
    return <Navigate to="/admin" replace />;
  }

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await login(email.trim(), password);
      navigate("/admin", { replace: true });
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="adm-login" data-testid="admin-login-page">
      <form className="adm-login-card" onSubmit={submit}>
        <img src="/lemur-logo.png" alt="Lemur Quality" />
        <h1>Admin panel</h1>
        <p className="sub">Sign in to manage the Lemur Quality website</p>
        {error && <div className="adm-error" data-testid="login-error">{error}</div>}
        <div className="adm-field">
          <label htmlFor="adm-email">Email</label>
          <input id="adm-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email" autoComplete="username" />
        </div>
        <div className="adm-field">
          <label htmlFor="adm-pass">Password</label>
          <input id="adm-pass" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password" autoComplete="current-password" />
        </div>
        <button className="adm-btn primary" style={{ width: "100%", justifyContent: "center", padding: "12px" }} disabled={busy} data-testid="login-submit">
          {busy ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </div>
  );
}
